module.exports = __webpack_public_path__ + "8fdddb5403e0a745683bdb18d0e35585.MP3";